var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0ZM18.4174 8.53102C19.0141 8.69474 19.484 9.17716 19.6434 9.78979C19.9332 10.9001 19.9332 13.2168 19.9332 13.2168C19.9332 13.2168 19.9332 15.5334 19.6434 16.6438C19.484 17.2564 19.0141 17.7388 18.4174 17.9027C17.3361 18.2001 12.9999 18.2001 12.9999 18.2001C12.9999 18.2001 8.66364 18.2001 7.58227 17.9027C6.98561 17.7388 6.51572 17.2564 6.35626 16.6438C6.06655 15.5334 6.06655 13.2168 6.06655 13.2168C6.06655 13.2168 6.06655 10.9001 6.35626 9.78979C6.51572 9.17716 6.98561 8.69474 7.58227 8.53102C8.66364 8.23346 12.9999 8.23346 12.9999 8.23346C12.9999 8.23346 17.3361 8.23346 18.4174 8.53102Z",
    fill: "#A0A6C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6992 15.5998V11.2665L15.1659 13.4332L11.6992 15.5998Z",
    fill: "#A0A6C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtb);
export default __webpack_public_path__ + "static/media/ytb.cadff0ccb3d3528105b01a00b9a278b0.svg";
export { ForwardRef as ReactComponent };